export enum EditMode {
    Add,
    Edit
}
